import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {
    CampaignsServiceModuleName,
    ContactProfileModuleName,
    PartnerProfileModuleName
} from "../utils/names/optionalModuleNames";
import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import {PartnerServiceName} from "../utils/names/serviceNames";
import {PartnerProfileController} from "./controller/profile/PartnerProfileController";
import {PartnerService} from "./service/PartnerService";
import {LoaderStatusValue} from "../loader/service/loaderStatus";
import {getTabName} from "modules/utils/TabNameUtils";

function getSelectedPartnerResolver() {
    return [
        PartnerServiceName,
        '$route',
        'LoaderStatusValue',
        function (partnerService: PartnerService,
                  $route: ng.route.IRouteService,
                  loader: LoaderStatusValue) {
            loader.on();
            return partnerService.fetchContactDetails($route.current.params.partnerId)
                .then(partner => {
                    loader.off();
                    return partner;
                });
        }]
}

export const PartnerProfileModuleConfiguration = new RestrictedRouteModuleConfiguration(
    PartnerProfileModuleName,
    [
        PartnerProfileModuleName,
        CampaignsServiceModuleName,
        ContactProfileModuleName
    ],
    [
        ["/partner_profile/:partnerId", {
            template: PartnerProfileController.template,
            controller: 'partnerProfileController',
            resolve: {
                'selectedContact': getSelectedPartnerResolver()
            }
        }]
    ],
    [],
    [PartnerProfileModuleName],
    [UserGranredAuthorityName.PARTNERS],
    getTabName() + '| Partner Profile'
);

export default PartnerProfileModuleConfiguration;